export default {
  devices: 'devices',
  device_status: 'device_status',
  web_rtc_stream_offer: 'webrtc_stream_offer',
  device_setting: 'device_settings',
  discover_devices_opcua: 'discover_devices_opcua',
  unsubscribe: 'unsubscribe',
  subscribe: 'subscribe',
};
